import PropTypes from 'prop-types';

export const Representative = {
	id: PropTypes.string,
	name: PropTypes.string,
	lastName: PropTypes.string,
	preferentialVotes: PropTypes.number,
	preferentialPercent: PropTypes.number
}

export const Mandates = {
	count: PropTypes.number,
	percent: PropTypes.number,
	list: PropTypes.arrayOf(PropTypes.shape(Representative))
}

export const RegionalParty = {
	id: PropTypes.number.isRequired,
	kid: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	shortcut: PropTypes.string.isRequired,
	fullName: PropTypes.string.isRequired,
	votes: PropTypes.number.isRequired,
	percent: PropTypes.number.isRequired,
	mandates: PropTypes.shape(Mandates)
}